import { createSlice } from "@reduxjs/toolkit";

export interface ColumnSettingsState {
    loading: boolean;
    columnSettings: any[]; // Change type if you have a proper interface
}

const initialState: ColumnSettingsState = {
    loading: false,
    columnSettings: [],
};

export const columnSettingsSlice = createSlice({
    name: "columnSettings",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload.value;
        },

        saveSuccess: (state) => {
            // You can set a flag here if needed
        },

        replaceColumnSettings: (state, action: { payload: { data: any[] } }) => {
            state.columnSettings = action.payload.data;
        },

        setAllColumns: (state, action: { payload: { data: any[] } }) => {
            state.columnSettings = action.payload.data;
        },

        resetColumnSettings: () => initialState,
    },
});

export const columnSettingsActions = columnSettingsSlice.actions;

export default columnSettingsSlice.reducer;
